<template>
  <section class="mb-auto pt-6 pb-12">
    <div class="max-w-xl mx-auto">
      <Intro :page="page" align="text-left">
        <button
          slot="header-content"
          type="button"
          class="btn text-left justify-start -ml-2 sm:ml-2"
          :disabled="loading"
          :loading="loading"
          @click="handleContinue"
        >
          {{ buttonText }}

          <ArrowRight class="w-3.5 h-3.5 ml-1 flex-shrink-0" />
        </button>
      </Intro>

      <div v-if="$slots.default" class="mb-5">
        <!--
          A slot for the main content of the step. This will most
          likely be an <Input /> and will display inside a card.
        -->
        <slot />
      </div>

      <!--
        Either use a custom button with <tag slot="button" />,
        or fallback to generic Continue button.
      -->
      <slot name="button">
        <button
          type="button"
          class="btn btn-primary btn-large w-full"
          :disabled="loading"
          :loading="loading"
          @click="handleContinue"
        >
          {{ buttonText }}

          <ArrowRight class="btn-icon-right" />
        </button>
      </slot>
    </div>
  </section>
</template>

<script>
import ArrowRight from '@/assets/svg/icons/arrow-right.svg?inline'
import Intro from '@/components/step-page/Intro'

export default {
  components: { ArrowRight, Intro },

  props: {
    input: { type: [String, Array], default: '' },
    page: { type: Object, default: () => ({}) },
    name: { type: String, required: true },
    loading: Boolean,
  },
  beforeDestroy() {
    window.removeEventListener('keypress', this.onKeyPress)
  },
  mounted() {
    window.addEventListener('keypress', this.onKeyPress)
  },
  computed: {
    /**
     * If the page is being skipped based on the input.
     *
     * @return {boolean}
     */
    skip() {
      return !this.input?.length
    },

    /*
     * Return button text based on user input.
     */
    buttonText() {
      return this.skip ? this.page?.button?.empty_text : this.page?.button?.text
    },
  },

  methods: {
    /**
     * Fire a ButtonClick GA Event and emit to the parent.
     */
    handleContinue($event) {
      this.$emit('continue', $event)
    },

    onKeyPress(e) {
      if (e?.key === 'Enter') this.handleContinue()
    },
  },
}
</script>
